import LogoutButton from "../../shared/auth_form/logout";
import { getLocationPathname } from "../../../../helpers/location-helpers";
import Routes from "routes";
import { compose } from "redux";
import PropTypes from "prop-types";
import withUserMenuTemplate from "../user-menu-template";

const MobileSideNavFooter = ({ howItWorksLink, hasProfile }) => {
  return (
    <div className={`grid ${hasProfile ? "grid-cols-3" : "grid-cols-2"} text-md`}>
      {howItWorksLink && (
        <a href={howItWorksLink?.url} className="justify-self-end" data-test-id="how-it-works--mobile">
          {howItWorksLink?.label}
        </a>
      )}
      <a
        href="/help/faq?_=1&customerpromise=true&placement=banner"
        className="justify-self-center"
        data-test-id="contact-us--mobile">
        Contact us
      </a>
      {hasProfile && (
        <LogoutButton
          actionData={{
            referring_url: getLocationPathname(),
            objectType: "mobile_nav",
            action: "click_menu_item",
            category_depth: "1",
            category_name: "sign_out",
          }}
          bold={false}
          className="user-menu-item-title-standalone justify-self-start"
          destination={Routes.Home}
          id="sign-out-collapsed"
          innerClassName="user-menu-item-title-label"
          searchParams={
            new URLSearchParams({ nav_location: "user_account", action: "click_sign_out", object_type: "top_nav" })
          }
          underline={false}>
          Sign Out
        </LogoutButton>
      )}
    </div>
  );
};

MobileSideNavFooter.propTypes = {
  howItWorksLink: PropTypes.object,
  hasProfile: PropTypes.bool,
};

export { MobileSideNavFooter };
export default compose(withUserMenuTemplate)(MobileSideNavFooter);
